// Neuladen aufschieben, solange Ungespeichertes offen ist
// (Repo-Prüfung 21.10.2026, zweite Runde).
//
// Das Homelab lädt sich selbst neu: nach einem Deploy, sobald das Fenster
// verdeckt wird (pwa.svelte.ts, applyPendingUpdate), und wenn nach einem
// Deploy ein Baustein fehlt (reloadForBrokenChunk). Ein offener Editor mit
// ungespeicherten Änderungen verlor dabei still seine Eingaben. Wer etwas
// Ungespeichertes hält, trägt sich hier ein -- in Svelte am besten an einem
// $derived, damit nicht jeder Tastendruck aus- und wieder einträgt:
//
//   const geaendert = $derived(...);
//   $effect(() => { if (geaendert) return haltNeuladen("vault-editor"); });
//
// Solange ein Eintrag besteht, lädt die Seite nicht von selbst neu (das
// vorgemerkte Update zieht beim nächsten Verstecken nach der Freigabe), und
// beforeunload fragt, bevor der Browser die Seite verlässt (Tab schließen,
// Neuladen per Hand). Das ist die einzige Rückfrage, die der Browser beim
// Verlassen zulässt -- eine eigene Zeile kann dort nichts mehr zeigen.

const halter = new Map<symbol, string>();

function verlassenFragen(e: BeforeUnloadEvent): void {
  e.preventDefault();
  // Ältere Browser fragen nur, wenn returnValue gesetzt ist.
  e.returnValue = "";
}

/** Neuladen aufhalten (grund: wer, fürs Protokoll). Zurück kommt die
 *  Freigabe; mehrfaches Freigeben schadet nicht. */
export function haltNeuladen(grund: string): () => void {
  const id = Symbol(grund);
  if (halter.size === 0 && typeof window !== "undefined") {
    window.addEventListener("beforeunload", verlassenFragen);
  }
  halter.set(id, grund);
  return () => {
    if (!halter.delete(id)) return;
    if (halter.size === 0 && typeof window !== "undefined") {
      window.removeEventListener("beforeunload", verlassenFragen);
    }
  };
}

/** Wer das Neuladen gerade aufhält (leer = frei). */
export function neuladenGehalten(): string[] {
  return [...halter.values()];
}
